import React, { useState, useEffect, useRef } from "react";
import "./ChooseSlot.scss";
import { useSelector } from "react-redux";

import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import dayjs from "dayjs";

const BookCalendar = (props) => {
  const [position, setPosition] = useState(0);
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  const weekRef = useRef(null);
  const [currMonth, setCurrMonth] = useState("");
  const [mobileYprevious, setMobileYPrevious] = useState(null);

  const daysNames = ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"];

  const { freeSlots, widget } = useSelector((state) => state.widget);

  useEffect(() => {
    const scrollOverride = (e) => {
      let y = 0;
      const slots = document.querySelectorAll(".slots");
      if (e.type === "touchmove") {
        y = e.touches[0].pageY;
        setMobileYPrevious(y);
        console.log("Previous", mobileYprevious);
        console.log("Current", y);
        if (mobileYprevious) {
          y = mobileYprevious - y;
        } else y = 0;
        console.log("Y", y);

        if (y < 50 || y > 50) {
        } else y = 0;

        if (y) {
          slots.forEach((slot) => {
            let scrolled = slot.scrollTop;
            slot.scroll(0, scrolled + y);
          });
        }
      } else {
        y = e.deltaY;

        slots.forEach((slot) => {
          let scrolled = slot.scrollTop;
          slot.scroll(0, scrolled + y / 5);
        });
      }
      e.preventDefault();
    };

    const touchEndCalled = (e) => {
      console.log("TOUCHEND");
      setMobileYPrevious(null);
    };

    if (weekRef.current) {
      weekRef.current.addEventListener("wheel", scrollOverride, {
        passive: false,
      });

      weekRef.current.addEventListener("touchmove", scrollOverride);
      weekRef.current.addEventListener("touchend", touchEndCalled);
    }
  }, [mobileYprevious]);

  const dayInWeek = (date, values) => {
    const dayName = daysNames[dayjs(date).day()];

    return (
      <div className="Day">
        <div className="title">
          <span>{dayName}</span>
          <p>{dayjs(date).format("DD")}</p>
        </div>
        <div className="slots">
          {values &&
            values.map(
              (time, index) =>
                time && (
                  <button
                    key={index}
                    onClick={() =>
                      props.select && props.select(date, time.from)
                    }
                    className="available"
                    style={{
                      color: widget.company.widget_settings.main_color
                        ? widget.company.widget_settings.main_color
                        : "#1A73E8",
                    }}
                  >
                    {time.from.substring(0, 5)}
                  </button>
                )
            )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (freeSlots) {
      const start = position * 5;
      // const len = Object.keys(freeSlots).length;
      // const end = position * 5 + 5 > len - 1 ? len - 1 : position * 5 + 5;
      // setStartDate(dayjs(Object.keys(freeSlots)[start]).format("DD"));
      // setEndDate(dayjs(Object.keys(freeSlots)[end]).format("DD"));
      setCurrMonth(
        `${dayjs(Object.keys(freeSlots)[start]).format("MMMM")} ${dayjs(
          Object.keys(freeSlots)[start]
        ).format("YYYY")}`
      );
    }
    // eslint-disable-next-line
  }, [position, currMonth, freeSlots]);

  return (
    <div className="BookCalendar">
      <div className="header">
        <h2>{currMonth}</h2>
      </div>

      <div className="week" ref={weekRef}>
        {freeSlots &&
          Object.keys(freeSlots)
            .slice(position > 0 ? position * 5 : position * 5, position * 5 + 5)
            .map((day) => {
              return dayInWeek(day, freeSlots[day]);
            })}
      </div>
      <div
        className="arrow left"
        onClick={() => position !== 0 && setPosition((p) => p - 1)}
      >
        <HiArrowLeft />
      </div>
      <div
        className="arrow right"
        onClick={() =>
          position <= Object.keys(freeSlots).length / 5 - 1 &&
          setPosition((p) => p + 1)
        }
      >
        <HiArrowRight />
      </div>
    </div>
  );
};

export default BookCalendar;
